import { z } from "zod";
import { emailRegex, phoneRegex } from "../../../lib/regex";
import { CustomerAccessEnum, UserRole } from "../dto";

export const userSchema = z.object({
    role: z.string().refine(val => Object.values(UserRole).includes(val as UserRole), { message: "Selezionare un ruolo" }),
    name: z.string().min(1, "Inserire il nome."),
    surname: z.string().min(1, "Inserire il cognome."),
    email: z.string().min(1, "Inserire l'email.").regex(emailRegex, "Email non valida."),
    phone: z.string().optional().nullable(),
    isAutonomous: z.boolean().optional(),
    customerAccess: z.string().refine(val => !val || Object.values(CustomerAccessEnum).includes(val as CustomerAccessEnum)).optional().nullable(),
    collaborators: z.array(z.string()).optional().nullable(),
    customerId: z.string().optional().nullable(),

    companyName: z.string().optional().nullable(),
    companyVat: z.string().optional().nullable(),
    companyAtecoCode: z.string().optional().nullable(),
    companySector: z.string().optional().nullable(),
    companyRevenue: z.number().optional().nullable(),
    companyWebsite: z.string().optional().nullable(),
});

export const validateNewUserSchema = userSchema.superRefine((user, ctx) => {
    if (user.role === UserRole.admin) {
        if (user.phone && !phoneRegex.test(user.phone)) {
            ctx.addIssue({ code: "custom", path: ["phone"], message: "Inserire un numero di telefono valido." });
        }
    } else {
        if (!user.phone || !phoneRegex.test(user.phone)) {
            ctx.addIssue({ code: "custom", path: ["phone"], message: "Il telefono è obbligatorio e deve essere valido." });
        }
    }

    if (user.role === UserRole.customer) {
        if (!user.companyName || user.companyName.trim() === "") {
            ctx.addIssue({ code: "custom", path: ["companyName"], message: "Inserire il nome dell'azienda." });
        }
        if (user.companyVat && (user.companyVat.length < 11 || user.companyVat.length > 16)) {
            ctx.addIssue({ code: "custom", path: ["companyVat"], message: "La partita IVA deve avere tra 11 e 16 caratteri." });
        }
    }
});

export type UserFormValues = z.infer<typeof userSchema>;
